
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64.9 64.9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.466 64.889c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5 32.5 14.6 32.5 32.5c-.1 18-14.6 32.5-32.5 32.5zm0-61.1c-15.8 0-28.7 12.9-28.7 28.7s12.9 28.7 28.7 28.7c15.8 0 28.7-12.9 28.7-28.7 0-15.8-12.9-28.7-28.7-28.7z","fill":"#707070"}}),_c('path',{attrs:{"d":"M13.714 46.759l12.9-12.9 4.5 4.6-12.9 12.9-4.5-4.6zM34.799 26.156l3.3-3.3 4.5 4.6-3.3 3.2-4.5-4.5z","fill":"#707070"}}),_c('path',{attrs:{"d":"M28.585 23.111l1.7-4-5.8-5.9-5.1 1.8 3.8 3.8-3.4 3.4-3.8-3.8-1.8 5.2 5.9 5.9 4-1.8 23.5 23.6 4.5-4.6-23.5-23.6z","fill":"#707070"}}),_c('path',{attrs:{"fill":"#00c972","d":"M35.856 54.433l-7.4-9.3 3-2.3 4.3 5.4 9.6-12.9 3 2.2z"}}),_c('g',[_c('path',{attrs:{"d":"M47.489 28.923l5-5-5.9-5.9-8.6-4.7-3 3.1 12.5 12.5z","fill":"#707070"}})])])
          )
        }
      }
    